<template>
  <nav class="socials">
    <a target="_blank" href="mailto:shzkimia@gmail.com" class="socials__link"><Mail class="socials__svg" /></a>
    <a target="_blank" href="" class="socials__link"><img :src="instagram" /><Instagram class="socials__svg" /></a>
    <a target="_blank" href="https://www.linkedin.com/in/kimiashz/" class="socials__link"><LinkedIn class="socials__svg" /></a>
    <a target="_blank" href="https://twitter.com/kilvlia" class="socials__link"><Twitter class="socials__svg" /></a>
    <a target="_blank" href="https://github.com/kimiashz" class="socials__link"><Github class="socials__github" /></a>
  </nav>
</template>

<script>
import Instagram from './components/Instagram';
import Github from './components/Github';
import Mail from './components/Mail';
import LinkedIn from './components/LinkedIn';
import Twitter from './components/Twitter';

export default {
  name: 'Socials',
  components: {
    Instagram,
    Github,
    Mail,
    LinkedIn,
    Twitter,
  }
}
</script>

<style lang="sass" scoped>
@import "@/styles/_variables.sass"

.socials
  display: flex
  justify-content: space-between
  flex-wrap: nowrap
  &__link
    width: $icon-size
    height: $icon-size
    padding: 0
    fill: $primary
    display: flex
    justify-content: center
  &__svg 
      display: inline-block
      width: inherit
      height: inherit
  &__github
    width: 80%
</style>
